var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:{
    'd-flex justify-space-between align-center px-2 px-md-5': true,
    'active-menu-item': _vm.active,
  },attrs:{"width":"100%","elevation":"0","color":"transparent","x-large":""},on:{"click":_vm.onClick}},[_c('p',{staticClass:"text-body text--primary mb-0"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('v-icon',{attrs:{"right":"","color":"primary","large":""}},[_vm._v(" mdi-chevron-right ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }